<template>
  <div class="app-page">
    <div class="login">
      <div class="login-form scrollbar">
        <div class="login-form__header">
          <img class="login-form__logo" src="../assets/img/edgefirst_hexagon.svg">
          <h1>Reset your password.</h1>
        </div>
        <div class="login-form__body">
          <form class="login-form__form" @submit.prevent="updatePassword(userChangePassword, userChangePasswordConfirm)">
            <label for="form_create-password">Password</label>
            <input
              id="form_create-password"
              v-model="userChangePassword"
              type="password"
              maxlength="72"
            >
            <label for="form_create-confirm_password">Confirm Password</label>
            <input
              id="form_create-confirm_password"
              v-model="userChangePasswordConfirm"
              type="password"
              maxlength="72"
            >
            <div class="submit-container">
              <span v-if="error" class="_error">{{ error }}</span>
              <button
                type="submit"
                class="button"
                :class="{'button-spinner': isLoading}"
                :disabled="isLoading"
              >
                Reset Password
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import { parseJwt } from '@/assets/js/utils.js';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

const $toast = useToast();

export default {
  name: 'ResetPassword',
  data() {
    return {
      userChangePassword: '',
      userChangePasswordConfirm: '',
      error: '',
      successMessage: '',
      token: null,
      isLoading: false,
    };
  },
  mounted() {
    this.token = this.$route.query.code;
    if (this.token) {
      try {
        const authUsername = this.parseJwt(this.token).username;
      } catch (err) {
        this.error = 'Invalid or expired reset link.';
      }
    } else {
      this.error = 'Reset token is missing.';
    }
  },
  methods: {
    parseJwt,
    async updatePassword(pw, conf) {
      if (!pw) {
        this.error = 'Missing password';
        return;
      }

      if (!conf) {
        this.error = 'Missing password confirmation';
        return;
      }

      if (pw !== conf) {
        this.error = 'Confirm password does not match password.';
        return;
      }

      if (!this.token) {
        this.error = 'Invalid Token.';
        return;
      }

      this.isLoading = true;
      const dataConnect = new DatastoreConnect();
      await dataConnect.resetUserPassword({ password: this.userChangePassword, token: this.token })
        .then((resp) => {
          if (resp.error !== undefined) {
            throw Error(resp.error.message);
          }
          this.isLoading = false;
          $toast.open({
            queue: true,
            duration: 5000,
            message: `Successfully reset password`,
            type: 'success',
            position: 'top',
          });
          this.$router.push({ path: '/login' });
        })
        .catch((error) => {
          this.isLoading = false;
          this.error = error;
        });
    },
  },

};
</script>

<style lang="scss" scoped>
.app-page {
  display: flex;
  flex-direction: row;
  text-align: center;
  overflow: visible;
  height: 100dvh;
  background-color: #250e81 !important;
  background-image: url("@/assets/img/blu-stripes.png") !important;
}

.login {
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  height: 100%;
  padding: 16px 100px;
  align-items: center;
  // justify-content: center;
  overflow: auto;
}

@media (max-width: $breakpoint-sm) {
  .login {
    padding: 8px;
  }
}
@media (max-width: $breakpoint-md) {
  .login {
    padding: 16px;
  }
}

.login-form {
  width: 610px;
  padding: 60px 80px 60px 80px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-height: fit-content;
  box-shadow: 0 0 35px rgb(0 0 0 / 50%), 0 0 10px rgb(0 0 0 / 50%);
  min-height: fit-content;
  margin: auto;
  @include themify() {
    background: themed('login-form');
    color: themed('body-text-color');
  }

  &__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 10;
    margin-bottom: 10px;

    h1 {
      margin-top: 10px;
      text-align: center;
      font-size: 24px;
    }
  }

  &__logo {
    max-width: 100%;
    height: 160px;
    object-fit: contain;
  }

  &__body {
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-bottom: 16px;
    flex: 1 1 auto;
    @include themify() {
      color: themed('body-text-color');
    }
  }

  .new-user {
    text-align: center;
    font-weight: normal;
    font-size: 16px;
    padding-top: 20px;
    margin-top: auto;
    margin-bottom: 0.5rem;
  }
}

@media (max-width: $breakpoint-sm) {
  .login-form {
    padding: 32px;
  }
}
@media (max-width: $breakpoint-md) {
  .login-form {
    width: 100%;
  }
}

form {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;

  label {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 2px;

      &.required::after {
      content: '*';
      font-size: 14px;
      font-weight: 700;
      padding-left: 1px;
      @include themify() {
        color: themed('color-primary');
      }
    }
  }

  input {
    width: 100%;
    height: 42px;
    background: transparent;
    padding: 10px;
    border: 2px solid rgb(189, 186, 186);
    border-radius: 8px;
    color: black;
    font-size: 16px;
    outline: none;

    &:focus, &:focus-visible {
      @include themify() {
        border: 2px solid themed('color-primary');
        box-shadow:  0 0px 2px themed('color-primary-300');
      }
      outline: 2px solid transparent;
      outline-offset: 2px;
    }
  }
  input:not(:last-of-type) {
    margin-bottom: 16px;
  }

  button[type=submit] {
    letter-spacing: 0.1em;
    width: 100%;
    height: 50px;
    border-radius: 6px;
  }

  .submit-container {
    margin-top: 16px;
    span._error {
      margin: 0 0 4px 0;
      font-weight: 400;
      font-size: 16px;
      text-align: left;
      margin-bottom: 0.5rem;
      @include themify() {
        color: themed('login-error');
      }
    }

    span._success {
      margin: 0 0 4px 0;
      font-weight: 400;
      font-size: 16px;
      text-align: left;
      margin-bottom: 0.5rem;
      @include themify() {
        color: themed('login-success');
      }
    }
  }
}
</style>
